module.exports = __webpack_public_path__ + "images/safari2.jpg?23a9ad27abda1163e1fc592daf9f05f6";